import { useRef, useState } from 'react';
import api from '@/lib/api';
import { toast } from 'sonner';
import { Upload, Loader2 } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function PhotoUpload({ value, onChange, category = 'misc', label = 'Photo', accept = 'image/*' }) {
  const inputRef = useRef(null);
  const [busy, setBusy] = useState(false);

  const handle = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true);
    const form = new FormData();
    form.append('file', file);
    try {
      const { data } = await api.post(`/admin/upload?category=${encodeURIComponent(category)}`, form, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      const fullUrl = data.url.startsWith('http') ? data.url : `${BACKEND_URL}${data.url}`;
      onChange(fullUrl);
      toast.success('Upload complete');
    } catch (err) {
      toast.error(err?.response?.data?.detail || 'Upload failed');
    } finally {
      setBusy(false);
      if (inputRef.current) inputRef.current.value = '';
    }
  };

  return (
    <div>
      <div className="text-sm font-semibold text-royal mb-1">{label}</div>
      <div className="flex items-center gap-3">
        {value ? (
          <img src={value} alt="" className="w-20 h-20 object-cover rounded-lg border" />
        ) : (
          <div className="w-20 h-20 rounded-lg border-2 border-dashed border-gray-300 flex items-center justify-center text-gray-400 text-xs">No image</div>
        )}
        <div className="flex-1">
          <input
            type="text"
            placeholder="https://... or upload a file"
            value={value || ''}
            onChange={(e) => onChange(e.target.value)}
            className="w-full px-3 py-2 border border-gray-200 rounded text-sm"
          />
          <button
            type="button"
            disabled={busy}
            onClick={() => inputRef.current?.click()}
            className="mt-2 inline-flex items-center gap-1 text-xs px-3 py-1.5 rounded-full bg-royal text-white hover:bg-royal-dark disabled:opacity-50"
          >
            {busy ? <Loader2 className="w-3 h-3 animate-spin" /> : <Upload className="w-3 h-3" />}
            {busy ? 'Uploading...' : 'Upload file'}
          </button>
          <input ref={inputRef} type="file" accept={accept} className="hidden" onChange={handle} />
        </div>
      </div>
    </div>
  );
}
